import { useBrandRequestContext } from '@/layouts/Brand/BrandRequestContext';
import { useRequestContext } from '@/routes/Requests/contexts/RequestContext';

export const useBrandOrAppRequestContext = () => {
  const {
    request: requestFromRequestContext,
    workflow: workflowFromRequestContext,
    view: viewFromRequestContext,
  } = useRequestContext();
  const {
    request: requestFromBrandRequestContext,
    workflow: workflowFromBrandRequestContext,
    view: viewFromBrandRequestContext,
  } = useBrandRequestContext();

  if (requestFromRequestContext) {
    return {
      request: requestFromRequestContext,
      workflow: workflowFromRequestContext,
      view: viewFromRequestContext,
    };
  } else {
    return {
      request: requestFromBrandRequestContext,
      workflow: workflowFromBrandRequestContext,
      view: viewFromBrandRequestContext,
    };
  }
};
